var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { placement: "top", width: "400", trigger: "click" },
      model: {
        value: _vm.enableEditEmail,
        callback: function ($$v) {
          _vm.enableEditEmail = $$v
        },
        expression: "enableEditEmail",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "Set new email" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      size: "small",
                      type: "email",
                      placeholder: _vm.customer.email,
                      "inline-message": "true",
                      disabled: _vm.loading,
                      clearable: "",
                    },
                    model: {
                      value: _vm.newEmail,
                      callback: function ($$v) {
                        _vm.newEmail = $$v
                      },
                      expression: "newEmail",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        disabled: _vm.loading,
                      },
                      on: { click: _vm.saveCustomerEmail },
                    },
                    [_vm._v("\n          Save\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.enableEditEmail = false
                        },
                      },
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticStyle: {
            color: "#f56c6c",
            padding: "0px",
            "font-size": "14px",
          },
          attrs: { slot: "reference", type: "text" },
          slot: "reference",
        },
        [_vm._v("\n    (Change)\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }